import { useState } from "react";
import { Box, InputAdornment, IconButton } from "@mui/material";
import { SendRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { withPather } from "react-pather";
import { URLInput, Page } from "../general";
import { PROJECT_NAME, PROJECT_DOMAIN } from "../../config";
import { extractLastPathnamePart } from "../../utils";

const CheckSubmit = ({ pather }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [url, setUrl] = useState("");

  const check = () => {
    if (!url.trim()) {
      enqueueSnackbar(`URL is not provided`, { variant: "error" });
      return;
    }

    try {
      const lastPart = extractLastPathnamePart(url);

      if (!lastPart) {
        enqueueSnackbar(`Link doesn't contain code part`, { variant: "error" });
        return;
      }

      const composedUrl = `${pather.reverse(pather.front.check, {
        code: lastPart,
      })}`;

      navigate(composedUrl);
    } catch (error) {
      enqueueSnackbar(`Invalid ${PROJECT_NAME} link`, { variant: "error" });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      check();
    }
  };

  return (
    <Page
      label={`Check Your ${PROJECT_NAME} Link`}
      sx={{ alignItems: "center" }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 3,
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <URLInput
            url={url}
            setUrl={setUrl}
            placeholder={`https://${PROJECT_DOMAIN}/your-code`}
            hideFavicon={true}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={check} edge="end">
                  <SendRounded />
                </IconButton>
              </InputAdornment>
            }
            onKeyDown={handleKeyDown}
          />
        </Box>
      </Box>
    </Page>
  );
};

export default withPather()(CheckSubmit);
